import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Checkbox, FormControl, IconButton, InputLabel, Grid, FormControlLabel,
         Hidden, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Snackbar, SnackbarContent, Switch,
         TextField, Tooltip, Typography
} from '@mui/material';

import { ArrowDropDown, Cancel, CheckCircle, Edit, PauseCircleFilled, PlayCircleFilled, CallMade, 
         Close, HourglassEmpty, HelpOutline, ForwardToInbox } from '@mui/icons-material';

import { getValueForRender } from '../../utils/InputUtils';
import BindCardPresentmentII from './BindCardPresentmentII';
import AppDisplay from '../ui/AppDisplay';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import SaveButton from '../ui/SaveButton';
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import PercentageTextField from '../ui/PercentageTextField';
import ServerError from '../ui/ServerError';
import InviteCustomerButton from '../ui/InviteCustomerButton';
import PasswordInput from '../ui/PasswordInput';
import AppBindStyles from '../../AppBindStyles';

import { red, green, blue, amber } from '@mui/material/colors';
import CustomerAppAudit from '../app/CustomerAppAudit';

const styleSheet = theme => ({
    root: {
      width: '100%',
    },
    statusButton: {
      color: '#444'
    },
    appBar: {
      backgroundColor: '#e5e5e5',
      height: 48,
      top: 'auto',
      bottom: 0,
    },
    bottomBarNavClosed: {
      marginLeft: 56
    },
    bottomBarNavOpen: {
      marginLeft: 200
    },
    divider: {
      marginTop: 4,
      marginBottom: 8,
      marginLeft: -2,
    },
    narrowButton: {
      // padding: 0,
      margin: 0,
    },
    typeicon: {
      verticalAlign: 'middle',
    },
    listItemIcon: {
      minWidth: 28,
      width: 28
    },
    selectField: {
        marginRight: theme.spacing(1),
        width: 240,
    },
    textField1: {
        margin: theme.spacing(1),
        width: 64,
    },
    markupField: {
      marginRight: theme.spacing(1),
      width: 64,
    },
    wholesaleDiscountField: {
      marginRight: theme.spacing(1),
      width: 64
    },
    markupReportingOnly: {
      margin: theme.spacing(1),
      width: 147,
    },
    textField2: {
        margin: theme.spacing(1),
        // marginTop: 6,
    },
    textFieldPerc: {
      margin: theme.spacing(1),
      // marginBottom: 6,
    },
    notesField: {
      marginTop: theme.spacing(1),
      // marginBottom: 6,
    },
    flexContainer: {
      display: 'flex',
      width: '100%'
    },
    flexFixed: {
      flex: 0,
      width: 104,
    },
    flexVariable: {
     flex: 1,
     marginRight: 16
    },
    paperFirst: {
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 1200,
      paddingTop: 16,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
    },
    paper: {
      textAlign: 'left',
      maxWidth: 1200,
      paddingTop: 16,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
    },
    paperInner: {
      textAlign: 'left',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(1),
    },
    emailField: {
      minWidth: 336,
    },
    additionalFields: {
      minWidth: 336,
    },
    forwardEmailCopy: {
      paddingLeft: 8,
      paddingRight: 8
    },
    iconButton: {
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 2,
      paddingBottom: 2,
    },
    iconButtonAction: {
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 3,
      paddingBottom: 2,
    },
    iconButtonRightMargin: {
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 2,
      paddingBottom: 2,
      marginRight: 36,
      // paddingLeft: 8,
      // paddingRight: 8
    },
    teamLabel: {
      // marginTop: 16
    },
    forwardEmailItem: {
      overflow: 'hidden',
      [theme.breakpoints.up('md')]: {
        marginTop: "-8px"
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: "0px"
      }
    },
    savesnackbar: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: green[300]
    }
});

const abEnvironment = new AbEnvironment();
const SubscriptionManageQuery = graphql`
query SubscriptionManageQuery($customerAppId: UUID!) {
  customerAppTByCustomerAppId(customerAppId: $customerAppId) {
    customerAppId
    appId
    customerAccountId
    parentAppId
    appStatus
    appSkuPrice
    appMarkupAbsolute
    appMarkupPercentage
    wholesaleDiscountPercentage
    notes
    paymentOrder
    bcId
    sharedEmail
    useEmail
    domain
    username
    pwd
    shareCredentials
    showSubscription
    passThroughFees
    soEntered
    domain
    username
    initiatedBy
    customerAppEmailTsByCustomerAppId {
      nodes {
         userId
         userTByUserId {
           email
         }
         accountId
         forwardEmail
       }
    }
    appTByAppId {
      appName
      appSku
      appUrl
      appLogo
      appType
      description
      signupUrl
      showDomain
      showUsername
      appTByOemAppId {
        appId
        accountTByAccountId {
          accountName
          vppTsByVendorId {
            totalCount
            nodes {
              vppId
              programName
              ctaText
              vppRTsByVppId {
                totalCount
                nodes {
                  stage
                }
              } 
            }
          }
        }
      }
    }
    bindCardTByBcId {
      bcId
      extBcId
      bcStatus
      usingAccountId
      accountTByUsingAccountId {
        contactEmail
        contactFirstName
        contactLastName
        paymentSourceTsByAccountId(condition: {psStatus: 0}) {
          totalCount
        }
        held4Using : paymentSourceTsByAccountId(condition: {psStatus: 4}) {
          totalCount
        }
        held5Using : paymentSourceTsByAccountId(condition: {psStatus: 5}) {
          totalCount
        }
        held6Using : paymentSourceTsByAccountId(condition: {psStatus: 6}) {
          totalCount
        }
        held7Using : paymentSourceTsByAccountId(condition: {psStatus: 7}) {
          totalCount
        }
        held8Using : paymentSourceTsByAccountId(condition: {psStatus: 8}) {
          totalCount
        }
        userTsByAccountId {
          nodes {
            userId
            email
            firstName
            lastName
          }
        }

      }
      provisioningAccountId
      accountTByProvisioningAccountId {
        contactEmail
        contactFirstName
        contactLastName
        accountStatus
        paymentSourceTsByAccountId(condition: {psStatus: 0}) {
          totalCount
        }
        held4Provisioning : paymentSourceTsByAccountId(condition: {psStatus: 4}) {
          totalCount
        }
        held5Provisioning : paymentSourceTsByAccountId(condition: {psStatus: 5}) {
          totalCount
        }
        held6Provisioning : paymentSourceTsByAccountId(condition: {psStatus: 6}) {
          totalCount
        }
        held7Provisioning : paymentSourceTsByAccountId(condition: {psStatus: 7}) {
          totalCount
        }
        held8Provisioning : paymentSourceTsByAccountId(condition: {psStatus: 8}) {
          totalCount
        }
				userTsByAccountId {
          nodes {
            userId
            email
            firstName
            lastName
          }
        }
      }
      firstName
      lastName
      address1
      address2
      city
      state
      postalCode
      country
    }
    accountTByCustomerAccountId {
      accountName
      accountId
      accountType
      contactEmail
      contactFirstName
      contactLastName
      contactEmail
      useBudgets
      latestBudgetApproved
      preApproveSubs
    }
    flowTaskTsByCustomerAppId {
      nodes {
        flowTaskId
        taskType
        taskData
        flowStepTsByFlowTaskId {
          nodes {
            flowStepId
            stepState
          }
        }
      }
    }
  }
}
`;

class SubscriptionManage extends Component {
  constructor(props)
  {
    super(props);

    this.state = {
      showSpinner:          false,
      confirmCancel:        false,
      confirmSuspend:       false,
      confirmUnsuspend:     false,
      appStatus:            null,
      appSkuPrice:          null,
      appMarkupAbsolute:    null,
      appMarkupPercentage:  null,
      wholesaleDiscountPercentage:  null,
      notes:                null,
      paymentOrder:         null,
      paymentOrderMenu:     null,
      anchorEl:             null,
      forceFetch:           0,
      useEmail:             null,
      unencryptPwd:         null,
      unencryptPwdChanged:  false,
      domain:               null,
      username:             null,
      pwd:                  null,
      changedEmails:        null,
      shareCredentials:     null,
      showSubscription:     null,
      passThroughFees:      null,
      saveStatus:           null,
      saveMessage:          null,
      saveSnackbarOpen:     false,
      saveSnackbarDuration: null,
      fromCreateSB:         false,
      backButtonText:       null,
      appBindAddress:       null
    };
  }

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) { window.analytics.page(); }

    const params = new URLSearchParams(this.props.location.search);
 
    let redirectedFrom = params.get('from');
    //console.log(redirectedFrom);
    if (redirectedFrom === "create") {
      this.setState({fromCreateSB: true, backButtonText: 'Add another subscription'})
    }

    const { callPartnerApi } = this.props.auth;


    let payload = {
      operation: "getAppBindAddress",
      params: {}
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then(resp => {
      return resp.json();
    })
    .then(response => {
      //console.log(response);
      this.setState({appBindAddress: response});
    });

  }

  /*** Navigation - go to different locations in AppBind, and handle an external app link ***/

  goToVpp(vppId) {
    this.props.history.push("/vendorpartnerprogram?vppId=" + vppId);
  }

  goToFundingSources(customerAppId) {
    if (customerAppId) {
      localStorage.setItem('subscriptionReturn', customerAppId);
    }

    this.props.history.push("/fundingsources");
  }

  goToAppEditSettings(appId) {
    if (appId === null)
      return;
      
    let url = 'app?appId=' + appId + '&fp=Manage Subscription&tab=settings';
    this.props.history.push(`${url}`);
  }    

  goToCustomerUserManagement(accountId) {
    localStorage.setItem('customerTabVal', 0);  //positions user on user tab
    localStorage.setItem('userInstructions', 'You can invite users below by first creating them and then sending them a customized email.');
    this.props.history.push("/customer?accountId=" + accountId);
  }
  
  goToCustomerFundingSources(accountId, customerAppId) {
    localStorage.setItem('subscriptionReturn', customerAppId);

    localStorage.setItem('customerTabVal', 1);  //positions user on funding tab
    this.props.history.push("/customer?accountId=" + accountId);
  }

  goToCustomerSubscriptions(accountId) {
    localStorage.setItem('customerTabVal', 3);  //positions user on subscriptions tab
    this.props.history.push("/customer?accountId=" + accountId + "&fp=Subscription");
  }

  goToSO(customer, openSubscriptionsByDefault) {
    let propsToCache = {
      accountId: customer.accountId,
      companyName: customer.accountName,
      contactLastName: customer.contactFirstName, 
      contactFirstName: customer.contactLastName, 
      contactEmail:  customer.contactEmail};
    localStorage.setItem('soCustomerParms', JSON.stringify(propsToCache));
    if (openSubscriptionsByDefault) {
      localStorage.setItem('soOpenSubscriptionsByDefault', true);
    }

    this.props.history.push(`/subscriptionorder`);
  }

  goToSubscriptionCreate(link) {
    this.props.history.push(link);
  }

  goToExternalApp(action, customerAppId, appId, appLink) {
    // TODO - if an extension function is available, call that.  Otherwise, just go to the link.
    abEnvironment.goToExternalApp(action, customerAppId, appId, appLink);
    // window.open(appLink, "_blank");
  }

  /*** General ui handlers ***/

  handleMenuClose = () => {
    this.setState({anchorEl: null});
  }
  handleMenuClick = event => {
    this.setState({anchorEl: event.currentTarget});
  }
  handleCheckChange() {
    if (this.state.paymentOrder === 1) {
      this.setState({ paymentOrder: 0 });
    } else {
      this.setState({ paymentOrder: 1 });
    }
  }

  toggleShareCredentials(shareCredentialVal) {
    if (shareCredentialVal === 1) {
      this.setState({ shareCredentials: 0 });
    } else {
      this.setState({ shareCredentials: 1 });
    }
  }

  toggleShowSubscription(showSubscriptionVal) {
    if (showSubscriptionVal === 1) {
      this.setState({ showSubscription: 0 });
    } else {
      this.setState({ showSubscription: 1 });
    }
  }

  togglePassThroughFees(passThroughFees) {
    if (passThroughFees === 1) {
      this.setState({ passThroughFees: 0 });
    } else {
      this.setState({ passThroughFees: 1 });
    }
  }

  disableForInvalidDomainName = (stateVar) => {
    if (stateVar !== null && stateVar !== '') {
         //Validate against reg ex domain check  (used this pattern: https://regexr.com/37i6s)
        var re = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/); 
        return !re.test(stateVar);
    } else {
      return true;
    }
  }

  /*
   * Invite a (customer) user to put a funding source on file to pay for the subscription.
   * This method will be passed to an invite component.
   */
  inviteCustomerUser = (bcUser) => {
    // If the user already exists, send them to the user edit to invite using that current user.
    // Otherwise, send to create.
    localStorage.setItem('subscriptionReturn', bcUser.customerAppId);

    if (bcUser.userid != null && bcUser.userid !== '') {
      let link = 'useredit?userId=' + bcUser.userid + '&accountId=' + bcUser.accountId + '&customerAppId=' + bcUser.customerAppId;
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription manage (inviting existing customer user)'); }
      this.props.history.push(link);
    } else {
      let propsToCache = {'contactLastName'  : bcUser.lastname,
                          'contactFirstName' : bcUser.firstname,
                          'contactEmail'     : bcUser.email};
      localStorage.setItem('userCreateParamProps', JSON.stringify(propsToCache));
      let link = 'usercreate?accountId=' + bcUser.accountId + '&customerAppId=' + bcUser.customerAppId;
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription manage (inviting new customer user)'); }
      this.props.history.push(link);
    }
  }

  /*
   * Reinvite a customer user to put a funding source on file to pay for the subscription.
   * This method will be passed to an invite component.
   */
  reinviteCustomerUser = (bcUser) => {
    localStorage.setItem('subscriptionReturn', bcUser.customerAppId);

    let link = 'useredit?userId=' + bcUser.userid + '&accountId=' + bcUser.accountId + '&customerAppId=' + bcUser.customerAppId;
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription manage (inviting existing customer user)'); }
    this.props.history.push(link);
  }

  determineBuySubscription = (customer) => {
    let useSOProcess = false;
    let lockdown = false;
    if (this.props.auth.isAuthenticatedReseller() && abEnvironment.getUserAttribute('a_useBudgets') !== '0' && customer.accountType === 4) {
      //looking at a subscription bought for customer
      if (customer.useBudgets >= 1) {
        useSOProcess = true;
      } else {
        lockdown = true;
      }
    } else if (this.props.auth.isAuthenticatedReseller() && abEnvironment.getUserAttribute('a_useBudgets') !== '0' && customer.accountType === 3) {
      //looking at a subscription bought for reseller.  Never used SO for reseller but could be lockdown
      lockdown = true;
    }

    if (useSOProcess) {
      this.goToSO(customer); 
    } else {
      let link = "subscriptioncreate?accountId=" + customer.accountId;
      if (lockdown) {
        link = link + '&ld=true';
      }
      this.goToSubscriptionCreate(link); 
    }
  }

  setClipboardVal(theText) {
    navigator.clipboard.writeText(theText)
    .then(() => {

    })
    .catch(err => {

    })
  }

  copySharedEmailToUseEmail() {
    this.setState({useEmail: this.state.sharedEmail});
  }

  disableSave(appProps, forwardingEmailList) {
    if (appProps === null)
      return true;

    let retval = this.disableAttributeCheck(this.state.appStatus,                   appProps.appStatus) &&
                 this.disableAttributeCheck(this.state.appSkuPrice,                 appProps.appSkuPrice) &&
                 this.disableAttributeCheck(this.state.appMarkupAbsolute,           appProps.appMarkupAbsolute) &&
                 this.disableAttributeCheck(this.state.appMarkupPercentage,         appProps.appMarkupPercentage) &&
                 this.disableAttributeCheck(this.state.wholesaleDiscountPercentage, appProps.wholesaleDiscountPercentage) &&
                 this.disableAttributeCheck(this.state.notes,                       appProps.notes) &&
                 this.disableAttributeCheck(this.state.paymentOrder,                appProps.paymentOrder) &&
                 this.disableAttributeCheck(this.state.useEmail,                    appProps.useEmail) &&
                 this.disableAttributeCheck(this.state.shareCredentials,            appProps.shareCredentials) &&
                 this.disableAttributeCheck(this.state.showSubscription,            appProps.showSubscription) &&
                 this.disableAttributeCheck(this.state.passThroughFees,             appProps.passThroughFees) &&
                 !this.state.unencryptPwdChanged;         

    if (retval && this.isShowDomain(appProps)) {
      retval = this.disableAttributeCheck(this.state.domain, appProps.domain);
    }
    if (retval && this.isShowUsername(appProps)) {
      retval = this.disableAttributeCheck(this.state.username, appProps.username);
    }
    
    if (retval) {
        //at least one has to be still on.
      let oneEmailSelected = false;
      for (let i = 0; i < forwardingEmailList.length; i++) {
        let entry = forwardingEmailList[i];
        if (entry.forwardEmail === 1) {
          oneEmailSelected = true;
          break;
        }
      }

      if (this.state.changedEmails && this.state.changedEmails.length > 0 && oneEmailSelected) {
        retval = false;
      }
    }

    if (this.areFieldsInError()) {
      return true;
    }

    return retval;
  }

  disableAttributeCheck(stateVar, propsVar)
  {
    if (stateVar !== null)
    {
      if (propsVar === null && stateVar === '')
        return true;

      if (propsVar !== stateVar)
        return false;
    }
    return true;
  }

  showSpinner() {
    return this.state.showSpinner;
  }

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  getValueForRenderMulti(...args) {
    for (let i = 0; i < args.length; i++) {
      if (args[i] != null) {
        return args[i];
      }
    }
  }

  // For select render, use the paymentOrderMenu state value
  // - that might not have been set.  In this case, derive the value
  //   from the paymentOrder state. If that hasn't been set,
  //   derive the value from the property that was sent in.
  getValueForSelectRender(propPaymentOrder) {
    if (this.state.paymentOrderMenu != null) {
      return this.state.paymentOrderMenu;
    }

    if (this.state.paymentOrder != null) {
      if (this.state.paymentOrder <= 1) {
        return 1;
      }
      else {
        return 2;
      }
    }

    if (propPaymentOrder != null) {
      if (propPaymentOrder <= 1) {
        return 1;
      } else {
        return 2;
      }
    }

    return 1;
  }

  goBack() {
    this.props.history.goBack();
  }

  setUnencryptedPassword(value) {
    this.setState({unencryptPwdChanged: true, unencryptPwd: value});
  }

  isShowDomain(theSubscription) {
    // Is there a task setting for the subscription?
    let theTask = null;
    if (theSubscription.flowTaskTsByCustomerAppId.nodes.length > 0) {
      theTask = theSubscription.flowTaskTsByCustomerAppId.nodes[0];
      if (theTask.taskType === 0) {
        let taskData = theTask.taskData;
        if (taskData.domain === true) {
          return true;
        }
      }
    }

    // Is there an app domain setting?
    let theApp = theSubscription.appTByAppId;
    if (theApp.showDomain === 1) {
      return true;
    }

    return false;
  }

  isShowUsername(theSubscription) {
    // Is there a task setting for the subscription?
    let theTask = null;
    if (theSubscription.flowTaskTsByCustomerAppId.nodes.length > 0) {
      theTask = theSubscription.flowTaskTsByCustomerAppId.nodes[0];
      if (theTask.taskType === 0) {
        let taskData = theTask.taskData;
        if (taskData.username === true) {
          return true;
        }
      }
    }

    // Is there an app username setting?
    let theApp = theSubscription.appTByAppId;
    if (theApp.showUsername === 1) {
      return true;
    }
    
    return false;
  }

  updateEmail = (emailCounter, userChanged, forwardingEmailList) => {
 
    let originalValue = forwardingEmailList[emailCounter];
    let changedList = this.state.changedEmails;

    //see if user was already changed
    let alreadyChanged = false;
    let alreadyChangedIndex = 0;
    if (changedList) {
       for (let i = 0; i < changedList.length; i++) {
        let previouslyChangedUser = changedList[i];
        if (previouslyChangedUser.email === userChanged.email) {
          alreadyChanged = true;
          alreadyChangedIndex = i;
          break;
        }
      }  
    } else {
      changedList = [];
    }

    if (!alreadyChanged) {
      //user changed, lets get them in the list
      if (originalValue.forwardEmail === 0) {
        userChanged.forwardEmail = 1;
      } else {
        userChanged.forwardEmail = 0;
      }
      changedList.push(userChanged);
    } else {
      changedList.splice(alreadyChangedIndex, 1);
    }

    this.setState({changedEmails: changedList});
  }

  isCardAddressAppBindCorporate(theBindcard) {
    //console.log(this.state.appBindAddress);
    if (this.state.appBindAddress === null) {
      return false;
    }
    if (this.state.appBindAddress.address1 !== theBindcard.address1) {
      return false;
    }
    if (this.state.appBindAddress.address2 !== theBindcard.address2) {
      return false;
    }
    if (this.state.appBindAddress.city !== theBindcard.city) {
      return false;
    }
    if (this.state.appBindAddress.state !== theBindcard.state) {
      return false;
    }
    if (this.state.appBindAddress.country !== theBindcard.country) {
      return false;
    }
    if (this.state.appBindAddress.postalCode !== theBindcard.postalCode) {
      return false;
    }
    return true;
   }

  getSharedEmailList(customerAppId, theBindcard, theForwardingEmailsFromProps) {
    //find the forwarding emails.  Challenge: there could be no rows in table in which case we mimic defaults.
    //process is: find all the users for provisioning and using account (if different).
    //            add a phantom user for primary(s)
    //            determine if they are already selected from the retrieved data.
    //            determine if they have since changed from the state data.
    let forwardingEmailList = [];
    //add a primary account
    let entry = {customerAppId: customerAppId, 
      userId: null, 
      accountId: theBindcard.provisioningAccountId, 
      firstName: theBindcard.accountTByProvisioningAccountId.contactFirstName,
      lastName: theBindcard.accountTByProvisioningAccountId.contactLastName,
      email: theBindcard.accountTByProvisioningAccountId.contactEmail, 
      forwardEmail: 1}
    forwardingEmailList.push(entry);

    for (let i = 0; i < theBindcard.accountTByProvisioningAccountId.userTsByAccountId.nodes.length; i++) {

      let user = theBindcard.accountTByProvisioningAccountId.userTsByAccountId.nodes[i];
      if (user.email !== theBindcard.accountTByProvisioningAccountId.contactEmail) {
        let entry = {customerAppId: customerAppId, 
          userId: user.userId, 
          accountId: theBindcard.provisioningAccountId, 
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          forwardEmail: 0}
        forwardingEmailList.push(entry);
      }
    }

    if (theBindcard.usingAccountId !== theBindcard.provisioningAccountId) {
      //add a primary account
      let entry = {customerAppId: customerAppId, 
      userId: null, 
      accountId: theBindcard.usingAccountId, 
      email: theBindcard.accountTByUsingAccountId.contactEmail, 
      firstName: theBindcard.accountTByUsingAccountId.contactFirstName,
      lastName: theBindcard.accountTByUsingAccountId.contactLastName,
      forwardEmail: 0}
      forwardingEmailList.push(entry);

      for (let i = 0; i < theBindcard.accountTByUsingAccountId.userTsByAccountId.nodes.length; i++) {


        let user = theBindcard.accountTByUsingAccountId.userTsByAccountId.nodes[i];
        if (user.email !== theBindcard.accountTByUsingAccountId.contactEmail) {
          let entry = {customerAppId: customerAppId, 
            userId: user.userId, 
            accountId: theBindcard.usingAccountId, 
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email, 
            forwardEmail: 0}
          forwardingEmailList.push(entry);
        }
      } 

    }

    //here we go through all the previous saved entries and mark the above accordingly
    for (let i = 0; i < theForwardingEmailsFromProps.nodes.length; i++) {
      let existing = theForwardingEmailsFromProps.nodes[i];
      //find the entry in the array and mark appropriately
      //console.log('existing=' + JSON.stringify(existing));

      for (let y = 0; y < forwardingEmailList.length; y++) {
        let listRow =  forwardingEmailList[y];
        //console.log('listRow = ' + JSON.stringify(listRow));

        if (existing.userId === null) {
          if (listRow.email === theBindcard.accountTByProvisioningAccountId.contactEmail && existing.accountId === theBindcard.provisioningAccountId) {
            //console.log('yes, provisioning ' + listRow.email);
            let forwardEmail = existing.forwardEmail;
            listRow.forwardEmail = forwardEmail;
            break;
          } else if (listRow.email === theBindcard.accountTByUsingAccountId.contactEmail  && existing.accountId === theBindcard.usingAccountId) {
            //console.log('yes, using ' + listRow.email);
            let forwardEmail = existing.forwardEmail;
            listRow.forwardEmail = forwardEmail;
            break;
          }
        } else {
          if (listRow.userId === existing.userId) {
            //console.log('yes, existing user ' + listRow.email);
            let forwardEmail = existing.forwardEmail;
            listRow.forwardEmail = forwardEmail;
            break;
          }
        }
      }
    }

    //here we go through all the changed entries in state (if any)
    if (this.state.changedEmails) {
      for (let i = 0; i < this.state.changedEmails.length; i++) {
        let changedEntry = this.state.changedEmails[i];
        //find the entry in the array and mark appropriately
        for (let y = 0; y < forwardingEmailList.length; y++) {
          if (forwardingEmailList[y].email === changedEntry.email) {
            let forwardEmail = changedEntry.forwardEmail;
            forwardingEmailList[y].forwardEmail = forwardEmail;
            break;
          }
        }
      }  
    }

    return forwardingEmailList;
  }

  getErrorMessage(field, minValue, maxValue) {
    let errMesg = null;

    let value = Number(field); 
    if (value < minValue) {
      return 'Cannot be less than ' + minValue;
    }
    if (value > maxValue) {
      return 'Cannot be greater than ' + maxValue;
    }

    return errMesg;
  }

  areFieldsInError() {
    if (this.getErrorMessage(this.state.appMarkupPercentage, -100, 900) !== null) {
      return true;
    }
    if (this.getErrorMessage(this.state.wholesaleDiscountPercentage, 0, 100) !== null) {
      return true;
    }
    return false;
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedCustomer, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;
    const cancelColor   = red[300];
    const suspendColor  = blue[300];
    const okColor       = green[300];
    const statusWaiting = amber[400];
    //const transferColor = purple[800];

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller() || isAuthenticatedCustomer()) {
      const params = new URLSearchParams(this.props.location.search);
      let customerAppId = params.get('customerAppId');

      let fp = params.get('fp');
      let backTo = "Subscriptions";
      if (fp != null && fp !== '') {
        backTo = fp;
      }
      if (this.state.backButtonText) {
        backTo = this.state.backButtonText;
      }
      //certain cases call for hiding of back button
      let hideback = false;
      
      if (params.get('hideback')) {
        hideback = true;
      } 

      let redirectedFrom = params.get('from');

      let wholesaleTooltip = `Some software vendors sell partners discounted subscriptions. You in turn then mark the subscription up and sell it to your customers.
      \n\r
      It’s important to show only the retail price for the subscription to your customer. Any discounts should come from you, which you can add on the next line below.`

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={SubscriptionManageQuery}
          variables={{customerAppId: customerAppId, forceFetch: this.state.forceFetch}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              if (props.customerAppTByCustomerAppId === null)
              {
                return (
                  <div className={classes.root}>
                    <PageTitle title="Subscription not found" showBackButton={true} name={backTo} history={this.props.history}/>
                  </div>
                );
              }

              //there might be a local storage attribute saved as part of the invite or add funding process.  
              //remove it now.
              var subscriptionReturn = localStorage.getItem('subscriptionReturn');
              if (subscriptionReturn) {
                localStorage.removeItem('subscriptionReturn');
              } 

              let theSubscription = props.customerAppTByCustomerAppId;
              let customerAccountId = theSubscription.customerAccountId;
              let theApp = theSubscription.appTByAppId;
              let theBindcard = theSubscription.bindCardTByBcId;
              let theForwardingEmails = theSubscription.customerAppEmailTsByCustomerAppId;
              let customerAccountName = theSubscription.accountTByCustomerAccountId.accountName;

              let authOnlySubscription = false;
              if (theBindcard.bcStatus === 4) {
                authOnlySubscription = true;
              }
              let customerInitiated = false;
              if (theSubscription.initiatedBy === 1) {
                customerInitiated = true;
              }
              let termsLockdown = true;
              //if the subscription was not entered in an SO, terms can be changed.
              if (theSubscription.soEntered === 0) {
                termsLockdown = false;
              } else {
                //if the customer has pre-approved, terms can be changed
                if (theSubscription.accountTByCustomerAccountId.preApproveSubs === 1) {
                  termsLockdown = false;
                }
              }

              //see if this app is in a vpp
              let vppExists = false;
              let vppId = false;
              let resellerInVpp = false;
              let resellerInVppAccepted = false;
              let vendorName = '';
              let ctaText = ''; 

              let oemApp = theSubscription.appTByAppId.appTByOemAppId;
              if (oemApp && oemApp.accountTByAccountId && oemApp.accountTByAccountId.vppTsByVendorId) {
                vendorName = oemApp.accountTByAccountId.accountName;
                
                if (oemApp.accountTByAccountId.vppTsByVendorId.nodes[0]) {
                  let vvp = oemApp.accountTByAccountId.vppTsByVendorId.nodes[0];
                  vppExists = true;
                  vppId = vvp.vppId;
                  ctaText = '' + vendorName + ' has a partner program. ' + vvp.ctaText;
                  if (vvp.vppRTsByVppId.totalCount > 0 && vvp.vppRTsByVppId.nodes[0].stage > 0) {
                    resellerInVpp = true;                  
                    if (vvp.vppRTsByVppId.nodes[0].stage > 1) {
                      resellerInVppAccepted = true;
                      ctaText = 'You are registered for the ' + vvp.programName + '.';
                    } else {
                      ctaText = "You've applied to the " + vvp.programName + ".";
                    }
                  }
                }
              }

              let isAppSuspended = false;
              if (theSubscription.appStatus === 1) {
                isAppSuspended = true;
              }

              let isAppCancelled = false;
              if (theSubscription.appStatus === 2) {
                isAppCancelled = true;
              }
              
              // For now, showing wholesale discount for all apps.  We anticipate
              // overriding this on an app by app basis in the future.
              let showWholesaleDiscount = true;
              
              let forwardingEmailList = this.getSharedEmailList(customerAppId, theBindcard, theForwardingEmails);
              let resellerEmailList = [];
              let customerEmailList = [];
              // if (forwardingEmailList.length > 2) {
                //the list above is in order of provisioning and then, if different, using.  Split them if needed
                for (let i = 0; i < forwardingEmailList.length; i++) {
                  let email = forwardingEmailList[i];
                  if (email.accountId === theBindcard.provisioningAccountId) {
                    resellerEmailList.push(email);
                  } else {
                    customerEmailList.push(email);
                  }
              //  }
              }

              let forwardEmailHelp  = 'An AppBind shared email forwards subscription email verifications and product alerts to you and your customer.';
              if (theBindcard.usingAccountId === theBindcard.provisioningAccountId) {
                forwardEmailHelp  = 'An AppBind shared email forwards subscription email verifications and product alerts to selected team members.';
              }
              if (authOnlySubscription) {
                forwardEmailHelp = 'An AppBind shared email forwards subscription email verifications and product alerts to you and your customer.';
                if (theBindcard.usingAccountId === theBindcard.provisioningAccountId) {
                  forwardEmailHelp = 'An AppBind shared email forwards subscription email verifications and product alerts to selected team members.';
                }
              }

              let sharedEmailHelp = "You can set up a shared login for you and your customer.";
              let sharedEmailHelpAuthOnly = "Your customer is sharing these credentials with you.";
              if (theBindcard.usingAccountId === theBindcard.provisioningAccountId) {
                sharedEmailHelp = "You can set up a shared login for your team.";
                sharedEmailHelpAuthOnly = "These credentials are shared with your team members.";
              }

              /*
              let sharedEmailTooltip = 'You can sign up for ' + theApp.appName + ' using an AppBind shared email.  Or if you prefer to use your own email address, you can save it here if you want to share login information with your team or customer.';
              if (theBindcard.usingAccountId === theBindcard.provisioningAccountId) {
                sharedEmailTooltip = 'You can sign up for ' + theApp.appName + ' using an AppBind shared email.  Or if you prefer to use your own email address, you can save it here if you want to share login information with your team.';
              }
              */

              //first make sure link url is prefixed correctly  TODO: after we finalize text in all cases, this Signup link redundancy below can be eliminated

              let signupDisabled = true;
              let urlWithProtocol = '';
              let urlWithProtocolDisplay = 'No link is set for this app';
              if (theApp.signupUrl && theApp.signupUrl !== '') {
                urlWithProtocol = (theApp.signupUrl.startsWith("http://") || theApp.signupUrl.startsWith("https://")) ? theApp.signupUrl :  "https://" + theApp.signupUrl;
                urlWithProtocolDisplay = urlWithProtocol;
                signupDisabled = false;
              } else if (theApp.appUrl && theApp.appUrl !== '') {
                urlWithProtocol = (theApp.appUrl.startsWith("http://") || theApp.appUrl.startsWith("https://")) ? theApp.appUrl :  "https://" + theApp.appUrl;
                urlWithProtocolDisplay = urlWithProtocol;
                signupDisabled = false;
              }

              let loginDisabled = true;
              let appUrlWithProtocol = '';
              if (theApp.appUrl && theApp.appUrl !== '') {
                appUrlWithProtocol = (theApp.appUrl.startsWith("http://") || theApp.appUrl.startsWith("https://")) ? theApp.appUrl :  "https://" + theApp.appUrl;
                loginDisabled = false;
              }

              let theUsePwdVal   = getValueForRender(this.state.pwd, theSubscription.pwd, '');
              let theUseEmailVal = getValueForRender(this.state.useEmail, theSubscription.useEmail, theSubscription.sharedEmail, null);
              let savedEmail     = getValueForRender(theSubscription.useEmail, theSubscription.sharedEmail, null);
              let theDomainVal   = getValueForRender(this.state.domain, theSubscription.domain, '');
              let theUsernameVal = getValueForRender(this.state.username, theSubscription.username, '');

              if (theSubscription.pwd == null || theSubscription.pwd === '' || savedEmail == null || savedEmail === '' || isAppCancelled === true) {
                loginDisabled = true;
              }
              if (theApp.showDomain === 1 && (theSubscription.domain == null || theSubscription.domain === '')) {
                loginDisabled = true;
              }
              if (theApp.showUsername === 1 && (theSubscription.username == null || theSubscription.username === '')) {
                loginDisabled = true;
              }

              let whoPays = null;
              let whoFor = null;

              if (theBindcard.usingAccountId !== theBindcard.provisioningAccountId) {
                whoFor = "customer";
                if (theSubscription.paymentOrder === 1 || theSubscription.paymentOrder === 0) {
                  whoPays = "customer";
                } else {
                  whoPays = "reseller";
                }
              } else {
                whoPays = "reseller";
                whoFor = "reseller";
              }
              // This is only relevant if the invite button is visible
              let who = customerAccountName;
              if (! who) {
                who = 'your customer';
              }
              let waitingOnApproval = false;
              if (theSubscription.accountTByCustomerAccountId.latestBudgetApproved === 0) {
                if (theSubscription.soEntered === 1) {
                  waitingOnApproval = true;
                }
              }
              let whott = 'Invite your customer to AppBind so that they can add a funding source to pay for subscriptions you manage for them';
              // These are only visible for expense to customer
              let viewSubscriptionText =  "Allow " + theSubscription.accountTByCustomerAccountId.accountName + " to view this subscription";
              let viewSubscriptionTooltip = "When you allow your customer to view a subscription, it will appear in the list of subscriptions in their customer portal.  If you want to share credentials with your customer, you'll need to allow your customer to view the subscription."

              // Visible for all
              // let shareCredentialsText = "Share credentials with " + theSubscription.accountTByCustomerAccountId.accountName;
              // let shareCredentialsTooltip = "If you share credentials, your customer will be able to view these credentials in the customer portal."

              let showBuyAnother = true; // always showing buy another button
              let buyAnotherLabel = "Add another subscription";
              let viewSubscriptionsLabel = "View subscriptions";
              if (whoFor === "customer") {
                buyAnotherLabel = buyAnotherLabel + " for " + theSubscription.accountTByCustomerAccountId.accountName;
                viewSubscriptionsLabel = viewSubscriptionsLabel + " for " + theSubscription.accountTByCustomerAccountId.accountName;
              }
              let createMessage = '';
              let showAddFundingSourceSection = false;
              let showPaymentCardSection = false;
              let showBusinessModelSection = false;
              let showNotesSection = false;
              let showRestrictedStatusSection = false; 

              let expensingActive = false;
              let expensing = abEnvironment.getFlagValue("expensing");
              if (expensing != null && expensing.flagValue === 1) {
                expensingActive = true;
              }          
        
              if (theBindcard.extBcId == null) {
                showAddFundingSourceSection = true;
                if (expensingActive === true) {
                  createMessage = "Success! Use this email to subscribe to " + theApp.appName + ". Once a funding source is available, we'll create a virtual credit card for you to use to pay with.";
                } else {
                  createMessage = "Success! Use this email to subscribe to " + theApp.appName + ".";
                }
              } else {
                showPaymentCardSection = true;
                createMessage = 'Success! Use this email and credit card to subscribe to ' + theApp.appName + '.';
              }

              //if the provisioning account is a pending status, we do not show card
              if (theBindcard.accountTByProvisioningAccountId.accountStatus === 2) {
                createMessage = 'Success! Once your account is active, we will issue an AppBind card.';
                showRestrictedStatusSection = true; 
              }
              //if the provisioning account is a suspended status, we do not show card
              if (theBindcard.accountTByProvisioningAccountId.accountStatus === 1) {
                showRestrictedStatusSection = true; 
              }

              let showExpenseSelf = true;
              let showExpenseCust = true;
              let usingAccountHasPaymentSource = false;
              if (theBindcard && theBindcard.accountTByUsingAccountId.paymentSourceTsByAccountId.totalCount > 0) {
                usingAccountHasPaymentSource = true;
              }

              let usingAccountHasHeldPaymentSource = false;
              if (theBindcard) {
                let heldCount = 0;
                heldCount = theBindcard.accountTByUsingAccountId.held4Using.totalCount;
                heldCount = heldCount + theBindcard.accountTByUsingAccountId.held5Using.totalCount; 
                heldCount = heldCount + theBindcard.accountTByUsingAccountId.held6Using.totalCount; 
                heldCount = heldCount + theBindcard.accountTByUsingAccountId.held7Using.totalCount; 
                heldCount = heldCount + theBindcard.accountTByUsingAccountId.held8Using.totalCount; 
                if (heldCount > 0) {
                  usingAccountHasHeldPaymentSource = true;
                }
              }
              let provisioningAccountHasPaymentSource = false;
              if (theBindcard && theBindcard.accountTByProvisioningAccountId.paymentSourceTsByAccountId.totalCount > 0) {
                provisioningAccountHasPaymentSource = true;
              }

              let provisioningAccountHasHeldPaymentSource = false;
              if (theBindcard) {
                let heldCount = 0;
                heldCount = theBindcard.accountTByProvisioningAccountId.held4Provisioning.totalCount;
                heldCount = heldCount + theBindcard.accountTByProvisioningAccountId.held5Provisioning.totalCount; 
                heldCount = heldCount + theBindcard.accountTByProvisioningAccountId.held6Provisioning.totalCount; 
                heldCount = heldCount + theBindcard.accountTByProvisioningAccountId.held7Provisioning.totalCount; 
                heldCount = heldCount + theBindcard.accountTByProvisioningAccountId.held8Provisioning.totalCount; 
                if (heldCount > 0) {
                  provisioningAccountHasHeldPaymentSource = true;
                }
              }

              if (theBindcard.provisioningAccountId !== theBindcard.usingAccountId) {
                showBusinessModelSection = true;
                if (theBindcard.extBcId != null && ! usingAccountHasPaymentSource) {
                  showExpenseCust = false;
                }
                if (theBindcard.extBcId != null && ! provisioningAccountHasPaymentSource) {
                  showExpenseSelf = false;
                }
              } else {
                showNotesSection = true;
              }

              var updateParms = null;
              if (theBindcard.extBcId == null) {
                updateParms = {
                  usingHasPs:        usingAccountHasPaymentSource,
                  provisioningHasPs: provisioningAccountHasPaymentSource,
                  bindCard:          theBindcard
                };
              }

              // let shareCredDisabled = (theUseEmailVal.length === 0 && theUsePwdVal.length === 0) || isAppCancelled;
              // let shareCredDisabled = isAppCancelled;
              // let shareCredVal      = this.getValueForRender(this.state.shareCredentials, theSubscription.shareCredentials, 1);
              let showSubVal        = this.getValueForRender(this.state.showSubscription, theSubscription.showSubscription, 1);
              let passThroughFees   = this.getValueForRender(this.state.passThroughFees, theSubscription.passThroughFees, 1);

              let emailCounter = 0;

              let showAppBindAddressTip = false;
              if (this.isCardAddressAppBindCorporate(theBindcard)) {
                showAppBindAddressTip = true;
              }

              let cancelConfirmMessage = 'Cancelling this subscription will cancel the virtual purchase card causing all future charges to be declined. Do you wish to proceed?';
              if (theBindcard.bcStatus === -1) {
                cancelConfirmMessage = 'Cancelling this subscription will stop a virtual purchase card being issued. Do you wish to proceed?';  
              } else if (theBindcard.bcStatus === 4) {
                cancelConfirmMessage = 'This subscription will be only visible when viewing cancelled subscriptions. Do you wish to proceed?';  
              }

              let suspendConfirmMessage = 'Suspending this subscription will cause all charges to be declined while the subscription is suspended. Do you wish to proceed?';
              let unsuspendConfirmMessage = 'Unsuspending this subscription will allow subscription charges to be accepted. Do you wish to proceed?';

              let pTitle = 'Subscription to ' + theApp.appName  + ' for ' + theSubscription.accountTByCustomerAccountId.accountName;

              // If this is an auth only subscription that has an invite task, get that information
              let theEmailInvitation = null;
              let donePrepend = "You've asked your customer to invite ";
              let addressArray = [];     
              let addrCount = 0;
              let sharedInvite = false;         
              if (theSubscription.flowTaskTsByCustomerAppId.nodes.length > 0) {
                let theTask = theSubscription.flowTaskTsByCustomerAppId.nodes[0];
                let taskDone = 0;
                if (theTask.flowStepTsByFlowTaskId.nodes.length > 0) {
                  let theStep = theTask.flowStepTsByFlowTaskId.nodes[0];
                  if (theStep.stepState === 1) {
                    taskDone = 1;
                    donePrepend = "Your customer has confirmed that they have invited ";
                  }
                }
        
                if (theTask.taskType === 1) {
                  sharedInvite = true;
                  let taskData = theTask.taskData;
                  if (taskData != null && taskData.inviteEmails != null && taskData.inviteEmails.length > 0) {
                    let emailArray = taskData.inviteEmails;
                    for (let i=0; i<emailArray.length; i++) {
                      let emailObj = emailArray[i];
                      if (emailObj.checked === true) {
                        addressArray.push(emailObj.email);
                      }
                    }
                    if (addressArray.length === 0) {
                      if (taskDone) {
                        theEmailInvitation = 'Your customer has confirmed that they have invited your team to their ' + theApp.appName + ' account.';
                      } else {
                        theEmailInvitation = 'Waiting for your customer to invite your team to their ' + theApp.appName + ' account.';
                      }
                    }      
                  }
                }
              }
  
              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    {!hideback &&
                    <PageTitle title={pTitle} showBackButton={true} name={backTo} noMargin={true} history={this.props.history}/>}
                    {hideback &&
                    <PageTitle title={pTitle} noMargin={true} history={this.props.history}/>}
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2} direction="row" >
                      <Grid item xs={12}>
                        <Paper className={classes.paperFirst}>
                          <Grid container spacing={2} direction="row" >
                            <Grid item xs={12} >
                              <Grid container spacing={0} direction="row-reverse" justifyContent='space-between' alignItems='flex-start'>

                                { (theBindcard.extBcId !== null || authOnlySubscription) && !isAppCancelled && !isAppSuspended &&
                                <Grid item>
                                  <Button color="secondary" 
                                    aria-owns={this.state.anchorEl ? 'simple-menu': undefined}
                                    aria-haspopup='true'
                                    onClick={this.handleMenuClick}
                                    className={classes.statusButton}
                                  >
                                    <CheckCircle htmlColor={okColor} /><Hidden only={['xs', 'sm']}>&nbsp;&nbsp;Active&nbsp;</Hidden><ArrowDropDown />
                                  </Button>
                                  <Menu
                                    id="action-menu"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={this.handleMenuClose}>
                                    {!authOnlySubscription &&
                                    <MenuItem onClick={() => {this.setState({anchorEl: null, confirmSuspend:true}); }}>
                                      <ListItemIcon className={classes.listItemIcon}>
                                        <PauseCircleFilled htmlColor={suspendColor}/>
                                      </ListItemIcon>
                                      <ListItemText primary="Suspend"/>
                                    </MenuItem>
                                    }
                                    <MenuItem onClick={() => {this.setState({anchorEl: null, confirmCancel:true}); }}>
                                      <ListItemIcon className={classes.listItemIcon}>
                                        <Cancel htmlColor={cancelColor}/>
                                      </ListItemIcon>
                                      <ListItemText primary="Cancel"/>
                                    </MenuItem>
                                  </Menu>
                                </Grid>}
                                { theBindcard.extBcId === null && !isAppCancelled && !isAppSuspended && !authOnlySubscription &&
                                <Grid item>
                                  <Button color="secondary" 
                                    aria-owns={this.state.anchorEl ? 'simple-menu': undefined}
                                    aria-haspopup='true'
                                    onClick={this.handleMenuClick}
                                    className={classes.statusButton}
                                  >
                                    <HourglassEmpty htmlColor={statusWaiting} /><Hidden only={['xs', 'sm']}>&nbsp;&nbsp;Pending&nbsp;</Hidden><ArrowDropDown />
                                  </Button>
                                  <Menu
                                    id="action-menu"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={this.handleMenuClose}>
                                    <MenuItem onClick={() => {this.setState({anchorEl: null, confirmCancel:true}); }}>
                                      <ListItemIcon className={classes.listItemIcon}>
                                        <Cancel htmlColor={cancelColor}/>
                                      </ListItemIcon>
                                      <ListItemText primary="Cancel"/>
                                    </MenuItem>
                                  </Menu>
                                </Grid>}

                                { isAppSuspended &&
                                <Grid item>
                                  <Button color="secondary" 
                                    aria-owns={this.state.anchorEl ? 'simple-menu': undefined}
                                    aria-haspopup='true'
                                    onClick={this.handleMenuClick}
                                    className={classes.statusButton}
                                  >
                                    <PauseCircleFilled htmlColor={suspendColor} /><Hidden only={['xs', 'sm']}>&nbsp;&nbsp;Suspended&nbsp;</Hidden><ArrowDropDown />
                                  </Button>
                                  <Menu
                                    id="action-menu"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={this.handleMenuClose}>
                                    <MenuItem onClick={() => {this.setState({anchorEl: null, confirmUnsuspend:true}); }}>
                                      <ListItemIcon className={classes.listItemIcon}>
                                        <PlayCircleFilled htmlColor={okColor}/>
                                      </ListItemIcon>
                                      <ListItemText primary="Unsuspend"/>
                                    </MenuItem>
                                    <MenuItem onClick={() => {this.setState({anchorEl: null, confirmCancel:true}); }}>
                                      <ListItemIcon className={classes.listItemIcon}>
                                        <Cancel htmlColor={cancelColor}/>
                                      </ListItemIcon>
                                      <ListItemText primary="Cancel"/>
                                    </MenuItem>
                                  </Menu>
                                </Grid>}

                                { isAppCancelled &&
                                <Grid item>
                                  <Button color="primary" disabled={true}>
                                    <Cancel htmlColor={cancelColor} /><Hidden only={['xs', 'sm']}>&nbsp;Cancelled&nbsp;</Hidden>
                                  </Button>
                                </Grid>}

                                <Grid item xs={9} style={{marginTop: 4}}>
                                  <AppDisplay appLogo={theApp.appLogo}
                                              appName={theApp.appName}
                                              appSku={theApp.appSku}
                                              description={theApp.description}
                                              appId={theSubscription.appId}
                                              history={this.props.history}
                                              fp={'Manage Subscription'}/>
                                </Grid>

                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>

                      {vppExists && !resellerInVpp &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                              <Typography><b>{ctaText}</b></Typography>
                            </Grid>
                            <Grid item>
                              <Button color="primary" variant="outlined" onClick={() => { this.goToVpp(vppId); }}>
                                Learn more
                              </Button>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>}
                      {vppExists && resellerInVpp && resellerInVppAccepted &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                              <Typography>{ctaText}</Typography>
                            </Grid>
                            <Grid item>
                              <Button color="primary" variant="outlined" onClick={() => { this.goToVpp(vppId); }}>
                                See program
                              </Button>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>}
                      {vppExists && resellerInVpp && !resellerInVppAccepted &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                              <Typography>{ctaText}</Typography>
                            </Grid>
                            <Grid item>
                              <Button color="primary" variant="outlined" onClick={() => { this.goToVpp(vppId); }}>
                                See program
                              </Button>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>}
                      
                      {/* Forwarding email setup.  This is shown for all kinds of subscriptions, but the description may differ. */}
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row">
                            <Grid item xs={12} >
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0} alignItems="center">
                                    <Grid item xs={12}>
                                      {/* sample code for icon in label */}
                                      {!isAppCancelled && !authOnlySubscription && false &&
                                      <Grid container spacing={1} alignItems="center">
                                        <Grid item><Typography variant="h6">1.</Typography></Grid>
                                        <Grid item><ForwardToInbox style={{ paddingTop: 3}}/></Grid>
                                        <Grid item><Typography variant="h6">Set up forwarding email</Typography></Grid>
                                      </Grid>}
                                      {!isAppCancelled && !authOnlySubscription && <Typography align="left" variant="h6">1. Set up forwarding email</Typography>}
                                      {!isAppCancelled && authOnlySubscription && <Typography align="left" variant="h6">Forwarding email</Typography>}
                                      {isAppCancelled && <Typography align="left" variant="h6">Forwarding email</Typography>}
                                    </Grid>
                                    <Grid item xs={12}>
                                      {isAppCancelled && <Typography variant="body2">{forwardEmailHelp}</Typography>}
                                      {! isAppCancelled && <Typography variant="body2">{forwardEmailHelp}</Typography>}
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                  <Paper className={classes.paperInner}>
                                    <Grid container spacing={0}>
                                      {/* List of emails */}
                                      {/* label={node.firstName + ' ' + node.lastName + ' (' + node.email + ')'} */}

                                      <Grid item xs={12}>
                                        <Grid container spacing={0}>
                                          <Grid item xs={12}>
                                            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                                              {/* <Grid item><Typography variant="body1">Forward</Typography></Grid> */}
                                              <Grid item>
                                                <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                                  <Grid item><ForwardToInbox style={{ paddingTop: 3, paddingRight: 6}}/></Grid>
                                                  <Grid item><Typography variant="body2"><b>{theSubscription.sharedEmail}</b></Typography></Grid>
                                                  <Grid item>
                                                    <Tooltip placement='bottom' title='Copy forwarding email to clipboard'>
                                                      <IconButton 
                                                        className={classes.forwardEmailCopy}
                                                        onClick={() => {this.setClipboardVal(theSubscription.sharedEmail); }}
                                                        size="large">
                                                        <img alt="Copy to Clipboard" 
                                                            src='/images/content_copy_black_24x24.png'
                                                            height="14px"/>
                                                      </IconButton>
                                                    </Tooltip> 
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>

                                          { customerEmailList.length === 0 && forwardingEmailList.map(n => {
                                            let node = n;
                                            let rowCounter = emailCounter;
                                            return (
                                              <Grid item key={(emailCounter++).toString()} className={classes.forwardEmailItem} style={{width: '420px'}}>
                                                <FormControlLabel  
                                                  control={<Checkbox checked={(node.forwardEmail === 1) ? true : false} 
                                                  disabled={isAppCancelled}
                                                  onChange={() => {this.updateEmail(rowCounter, node, forwardingEmailList)} } />}
                                                  label={<Typography variant="body2"><b>{node.firstName + ' ' + node.lastName}</b> ({node.email})</Typography>}
                                                />
                                              </Grid>
                                            );
                                          }) }

                                          { (customerEmailList.length > 0) && (resellerEmailList.length > 0) && 
                                          <Grid item xs={12} md={6}>
                                            <Grid container spacing={0} alignItems="center">
                                              <Grid item xs={12}>
                                                <InputLabel shrink className={classes.teamLabel}>My team</InputLabel>
                                              </Grid>
                                              { resellerEmailList.map(n => {
                                                let node = n;
                                                let rowCounter = emailCounter;
                                                return (
                                                  <Grid item xs={12} key={(emailCounter++).toString()} className={classes.forwardEmailItem}>
                                                    <FormControlLabel  
                                                      control={<Checkbox checked={(node.forwardEmail === 1) ? true : false} 
                                                      disabled={this.props.disabled}
                                                      onChange={() => {this.updateEmail(rowCounter, node, forwardingEmailList)} } />}
                                                      label={<Typography variant="body2"><b>{node.firstName + ' ' + node.lastName}</b> ({node.email})</Typography>}
                                                    />
                                                  </Grid>);
                                                })}
                                              </Grid>
                                          </Grid>}

                                          { (customerEmailList.length > 0) && 
                                          <Grid item xs={12} md={6}>
                                            <Grid container spacing={0} alignItems="center">
                                              {/*<Grid item xs={12} >
                                                <Typography variant="caption">My customer's account</Typography>
                                                </Grid>*/}
                                              <InputLabel shrink className={classes.teamLabel}>Customer Team</InputLabel>
                                              { customerEmailList.map(n => {
                                                let node = n;
                                                let rowCounter = emailCounter;
                                                //console.log(JSON.stringify(node));
                                                return (
                                                  <Grid item xs={12} key={(emailCounter++).toString()} className={classes.forwardEmailItem}>
                                                    <FormControlLabel  
                                                      control={<Checkbox checked={(node.forwardEmail === 1) ? true : false} 
                                                      disabled={this.props.disabled}
                                                      onChange={() => {this.updateEmail(rowCounter, node, forwardingEmailList)} } />}
                                                      label={<Typography variant="body2"><b>{node.firstName + ' ' + node.lastName}</b> ({node.email})</Typography>}
                                                    />
                                                  </Grid>);
                                                })}
                                            </Grid>
                                          </Grid>}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Maintenance Buttons */}
                            {!isAppCancelled && !customerInitiated &&
                            <Grid item xs={12} >
                              <Grid container spacing={3} direction="row" justifyContent="space-between">
                                <Grid item>
                                  <SaveButton
                                    buttonStyle={AppBindStyles.bottomButtonPaper6}
                                    snackbarOpen={this.state.saveSnackbarOpen}
                                    autoHideDuration={this.state.saveSnackbarDuration}
                                    status={this.state.saveStatus} 
                                    message={this.state.saveMessage}
                                    disabled={this.disableSave(theSubscription, forwardingEmailList)}
                                    onSaveClick={() => { this._updateCustomerApp(theSubscription.customerAppId, customerAccountId, theSubscription, theBindcard, updateParms, forwardingEmailList); }}
                                    onSnackbarClose={() => { this._onSnackbarClose(); }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>}
                          </Grid>

                          <Snackbar
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            open={this.state.fromCreateSB}
                            autoHideDuration={5000}
                            onClose={() => { this.handleFromCreateSnackbarClose(); }}
                          >
                            <SnackbarContent
                              className={classes.savesnackbar}
                              onClose={() => { this.handleFromCreateSnackbarClose(); }}
                              message={
                                <Typography variant="body1">
                                    {createMessage}
                                </Typography>
                              }
                              action={[
                                <IconButton key="close" 
                                            aria-label="Close" 
                                            color="inherit"
                                            className={classes.close}
                                            onClick={() => { this.handleFromCreateSnackbarClose(); }}
                                            size="large">
                                  <Close />
                                </IconButton>
                              ]}
                            />
                          </Snackbar>
                        </Paper>
                      </Grid>
                      
                      {/* Invite */}
                      {sharedInvite === true &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row">
                            {/* Heading */}
                            <Grid item xs={12}>
                              <Grid container spacing={0} alignItems="center">
                                <Grid item xs={12}>
                                  <Typography align="left" variant="h6">Invitation</Typography>
                                </Grid>
                                {/*
                                <Grid item xs={12}>
                                  <Typography variant="body2"></Typography>
                                </Grid>
                                */}
                              </Grid>
                            </Grid>

                            {theEmailInvitation != null &&
                            <Grid item xs={12}>
                              <Typography variant="body1">{theEmailInvitation}</Typography>
                            </Grid>}
                            {theEmailInvitation === null &&
                            <Grid item xs={12}>
                              <Typography variant="body1">
                                {donePrepend}&nbsp;
                                {addressArray.map(n => {
                                  let theEmail = addressArray[addrCount];
                                  let thePrepend = '';
                                  if (addrCount > 0) {
                                    if (addrCount === addressArray.length - 1) {
                                      if (addressArray.length > 2) {
                                        thePrepend = ',';
                                      }
                                      thePrepend = thePrepend + ' and ';
                                    } else {
                                      thePrepend = ', ';
                                    }
                                  }
                                  
                                  addrCount++;

                                  return (
                                    <span key={addrCount}>{thePrepend}<strong>{theEmail}</strong></span>
                                  );
                                })}
                                &nbsp;to their {theApp.appName} account.
                              </Typography>
                            </Grid>}   
                          </Grid>                     
                        </Paper>
                      </Grid>}

                      {/* Credentials */}
                      {sharedInvite === false &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row">
                            {/* Heading */}
                            <Grid item xs={12}>
                              <Grid container spacing={2} justifyContent="space-between" alignItems="flex-start" direction="row">
                                <Grid item xs={8}>
                                  <Grid container spacing={0} alignItems="center">
                                    <Grid item xs={12}>
                                      {!isAppCancelled && !authOnlySubscription && <Typography align="left" variant="h6">2. Set up shared login</Typography>}
                                      {!isAppCancelled && authOnlySubscription && <Typography align="left" variant="h6">Shared login</Typography>}
                                      {isAppCancelled && <Typography align="left" variant="h6">Shared login</Typography>}
                                    </Grid>
                                    <Grid item xs={12}>
                                      {! isAppCancelled && !authOnlySubscription && <Typography variant="body2">{sharedEmailHelp}</Typography>}
                                      {! isAppCancelled && authOnlySubscription && <Typography variant="body2">{sharedEmailHelpAuthOnly}</Typography>}
                                      {isAppCancelled && <Typography variant="body2">{sharedEmailHelp}</Typography>}
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item>
                                  <Button color="primary" 
                                          variant="outlined"
                                          disabled={loginDisabled}
                                          onClick={() => this.goToExternalApp('appLogin', customerAppId, null, appUrlWithProtocol)}>
                                    Login&nbsp;<CallMade/>
                                  </Button> 
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Auth fields */}
                            <Grid item xs={12}>
                              <Grid container spacing={1} alignItems="center">

                                {/* Domain */}
                                {this.isShowDomain(theSubscription) === true &&
                                <Grid item xs={12}>
                                  <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                      <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                          <Typography variant="body1" style={AppBindStyles.boldLabel}>Domain</Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item>
                                      <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                                        <Grid item>
                                          <TextField
                                            id="domain" className={classes.additionalFields}
                                            value={theDomainVal}
                                            onChange={ (e) => { this.setState({ domain: e.target.value }); } }
                                          />
                                        </Grid>
                                        <Grid item>
                                          <Tooltip placement='bottom' title='Copy domain to clipboard'>
                                            <IconButton
                                              className={classes.iconButtonRightMargin}
                                              onClick={() => {this.setClipboardVal( theDomainVal ); }}
                                              size="large">
                                              <img alt="Copy to Clipboard" 
                                                  src='/images/content_copy_black_24x24.png' 
                                                  height="16px"/>
                                            </IconButton>
                                          </Tooltip>     
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>}

                                {/* Username */}
                                {this.isShowUsername(theSubscription) === true &&
                                <Grid item xs={12}>
                                  <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                      <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                          <Typography variant="body1" style={AppBindStyles.boldLabel}>User name</Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item>
                                      <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                                        <Grid item>
                                          <TextField
                                            id="username" className={classes.additionalFields}
                                            value={theUsernameVal}
                                            onChange={ (e) => { this.setState({ username: e.target.value }); } }
                                          />
                                        </Grid>
                                        <Grid item>
                                          <Tooltip placement='bottom' title='Copy username to clipboard'>
                                            <IconButton
                                              className={classes.iconButtonRightMargin}
                                              onClick={() => {this.setClipboardVal(theUsernameVal); }}
                                              size="large">
                                              <img alt="Copy to Clipboard" 
                                                  src='/images/content_copy_black_24x24.png' 
                                                  height="16px"/>
                                            </IconButton>
                                          </Tooltip>     
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>}

                                {/* Email */}
                                <Grid item xs={12}>
                                  <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                      <Typography variant="body1" style={AppBindStyles.boldLabel}>Email</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                                        <Grid item>
                                          <TextField className={classes.emailField} id="your-provided-email" 
                                            disabled={isAppCancelled}
                                            value={theUseEmailVal}
                                            onChange={(e) => { this.setState({ useEmail: e.target.value });}}
                                          />
                                        </Grid>
                                        <Grid item>
                                          <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                            <Grid item>
                                              <Tooltip placement='bottom' title='Copy email to clipboard'>
                                                <IconButton
                                                  className={classes.iconButton}
                                                  onClick={() => {this.setClipboardVal(theUseEmailVal); }}
                                                  size="large">
                                                  <img alt="Copy to Clipboard" 
                                                      src='/images/content_copy_black_24x24.png' 
                                                      height="16px"/>
                                                </IconButton>
                                              </Tooltip>     
                                            </Grid>
                                            <Grid item>
                                              <Tooltip placement='bottom' title='Use forwarding email for login'>
                                                <IconButton
                                                  className={classes.iconButtonAction}
                                                  onClick={() => { this.copySharedEmailToUseEmail(); }}
                                                  size="large">
                                                  <ForwardToInbox/>
                                                </IconButton>
                                              </Tooltip>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                {/* Password */}
                                {!customerInitiated &&
                                <Grid item xs={12}>
                                  <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                      <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                          <Typography variant="body1" style={AppBindStyles.boldLabel}>Password</Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item>
                                      <PasswordInput
                                        name="password"
                                        disabled={isAppCancelled}
                                        auth={this.props.auth}
                                        customerAppId={customerAppId}
                                        pwd={theUsePwdVal}
                                        onChange={(e) => {this.setUnencryptedPassword(e)}}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>}

                                {/* Share credentials switch */}
                                {/*
                                {!authOnlySubscription &&
                                <Grid item xs={12} >
                                  <Grid container justifyContent="space-between" alignItems="center" spacing={0} style={{marginTop: '8px'}}>
                                    <Grid item>
                                      <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                        <Grid item>
                                          <Typography  variant="body1" style={AppBindStyles.boldLabel}>{shareCredentialsText}</Typography>
                                        </Grid>
                                        <Grid item>
                                          <Tooltip placement='bottom' title={shareCredentialsTooltip}>
                                            <HelpOutline fontSize="small" style={{verticalAlign: "-7%", marginLeft: '4px'}}/>
                                          </Tooltip>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item>
                                      <Switch checked={shareCredVal === 1} 
                                              disabled={shareCredDisabled}
                                              onChange={(e) => this.toggleShareCredentials(shareCredVal)} 
                                              value={shareCredVal}
                                              color="primary"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>}
                                */}
                              </Grid>
                            </Grid>


                            {/* Maintenance Buttons */}
                            {!isAppCancelled && !customerInitiated &&
                            <Grid item xs={12} >
                              <Grid container spacing={3} direction="row" justifyContent="space-between">
                                <Grid item>
                                  <SaveButton
                                    buttonStyle={AppBindStyles.bottomButtonPaper6}
                                    snackbarOpen={this.state.saveSnackbarOpen}
                                    autoHideDuration={this.state.saveSnackbarDuration}
                                    status={this.state.saveStatus} 
                                    message={this.state.saveMessage}
                                    disabled={this.disableSave(theSubscription, forwardingEmailList)}
                                    onSaveClick={() => { this._updateCustomerApp(theSubscription.customerAppId, customerAccountId, theSubscription, theBindcard, updateParms, forwardingEmailList); }}
                                    onSnackbarClose={() => { this._onSnackbarClose(); }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>}

                            <Snackbar
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              open={this.state.fromCreateSB}
                              autoHideDuration={5000}
                              onClose={() => { this.handleFromCreateSnackbarClose(); }}
                            >
                              <SnackbarContent
                                className={classes.savesnackbar}
                                onClose={() => { this.handleFromCreateSnackbarClose(); }}
                                message={
                                  <Typography variant="body1">
                                      {createMessage}
                                  </Typography>
                                }
                                action={[
                                  <IconButton
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className={classes.close}
                                    onClick={() => { this.handleFromCreateSnackbarClose(); }}
                                    size="large">
                                  <Close />
                                </IconButton>
                              ]}
                            />
                          </Snackbar>

                          </Grid>
                        </Paper>
                      </Grid>}

                      {!isAppCancelled && !authOnlySubscription &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" >
                            <Grid item xs={12}>
                              <Grid container alignItems="center">
                                <Grid item>
                                  <Typography align="left" variant="h6" >3. Sign up</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">If {theApp.appName} has assigned you a partner sign up link, you can use that instead.</Typography>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={2} justifyContent="space-between" >
                                <Grid item>
                                  <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                    <Grid item>
                                      <Typography variant="body1" sx={{textDecoration: 'underline'}} style={AppBindStyles.boldLabel}>{urlWithProtocolDisplay}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title='Edit link in app settings'>
                                        <IconButton
                                          onClick={() => { this.goToAppEditSettings(theSubscription.appId); }}
                                          size="small"
                                        >
                                          <Edit/>
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title="This is the url that you'll be directed to when you click the Sign up button.  If you have a referral link, you can edit this on the app catalog settings page for this app.">
                                        <HelpOutline fontSize="small" style={{verticalAlign: "-10%"}}/>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item>
                                  <Grid container spacing={2}>
                                    <Grid item>
                                      <Button color="primary" 
                                              variant="outlined"
                                              disabled={signupDisabled}
                                              onClick={() => this.goToExternalApp('appSignup', customerAppId, null, urlWithProtocol)}>
                                        Sign&nbsp;up&nbsp;<CallMade/>
                                      </Button> 
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>                    
                      </Grid>}

                      {!isAppCancelled && !authOnlySubscription &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" >
                            { showRestrictedStatusSection &&
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                      <Typography align="left" variant="h6">4. Pay with virtual purchase card</Typography>
                                    </Grid>    
                                    { theBindcard.accountTByProvisioningAccountId.accountStatus === 1 &&                      
                                    <Grid item xs={12}>
                                      <Typography variant="body2">The virtual purchase card can no longer be shown due to your account status.</Typography>
                                    </Grid>
                                    }
                                    { theBindcard.accountTByProvisioningAccountId.accountStatus === 2 &&                      
                                    <Grid item xs={12}>
                                      <Typography variant="body2">The virtual purchase card for {theApp.appName} hasn't been created yet but will when your account is activated.</Typography>
                                    </Grid>
                                    }
                                  </Grid>
                                </Grid>
                              

                                <Grid item xs={12}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                      <img alt="App" height="100px" src={'/cards/bindcard-blank.png'} />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>}

                            { showAddFundingSourceSection && !showRestrictedStatusSection &&
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                      <Typography align="left" variant="h6">4. Pay with virtual purchase card</Typography>
                                    </Grid>                          
                                    <Grid item xs={12}>
                                      <Typography variant="body2">A virtual purchase card for {theApp.appName} hasn't been created yet.</Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              

                                {(whoPays === "customer") &&
                                <Grid item xs={12}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                      <img alt="App" height="100px" src={'/cards/bindcard-blank.png'} />
                                    </Grid>
                                    {!waitingOnApproval &&
                                    <Grid item xs={12} md={9}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <Typography align="left" variant="body1" ><strong>No funding source is connected.</strong> Invite your customer to connect a funding source&mdash;or connect one yourself. Then we'll create a purchase card you can use to buy this subscription.</Typography>
                                        </Grid>
                                        <Grid item>
                                          <InviteCustomerButton buttonType={false}
                                                        disabled={false} 
                                                        auth={this.props.auth}
                                                        accountId={customerAccountId} 
                                                        customerAppId={theSubscription.customerAppId}
                                                        whoInvite={who}
                                                        whoTooltip = {whott}
                                                        reInvite={this.reinviteCustomerUser} 
                                                        invite={this.inviteCustomerUser} />
                                        </Grid>
                                        <Grid item>
                                          <Button color="primary" variant="outlined" onClick={() => { this.goToCustomerFundingSources(theBindcard.usingAccountId, customerAppId); }}>
                                            Connect Funding Source
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    }
                                    {waitingOnApproval &&
                                    <Grid item xs={12} md={9}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <Typography align="left" variant="body1" ><strong>Waiting for customer approval.</strong> A virtual card will be active when your customer approves their budget.</Typography>
                                        </Grid>
                                    </Grid>
                                    </Grid>
                                    }
                                  </Grid>
                                </Grid>
                                }
                                {(whoPays === "reseller")  &&
                                <Grid item xs={12}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                      <img alt="App" height="100px" src={'/cards/bindcard-blank.png'} />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                      {(provisioningAccountHasHeldPaymentSource || usingAccountHasHeldPaymentSource) &&
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <Typography align="left" variant="subtitle1">You have a funding source that is in process of verification.</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                          <Button color="primary" variant="contained"  onClick={() => { this.goToFundingSources(); }}>
                                            Check funding source status
                                          </Button>
                                        </Grid>
                                      </Grid>}
                                      {(!provisioningAccountHasHeldPaymentSource && !usingAccountHasHeldPaymentSource) && !waitingOnApproval &&
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <Typography align="left" variant="body1"><strong>No funding source is connected.</strong> When you connect a funding source, we'll create a purchase card you can use to buy this subscription.</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                          <Button color="primary" variant="contained"  onClick={() => { this.goToFundingSources(customerAppId); }}>
                                            Connect funding source
                                          </Button>
                                        </Grid>
                                      </Grid>}
                                      {(!provisioningAccountHasHeldPaymentSource && !usingAccountHasHeldPaymentSource) && waitingOnApproval &&
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <Typography align="left" variant="body1" ><strong>Waiting for customer approval.</strong> A virtual card will be active when your customer approves their budget.</Typography>
                                        </Grid>
                                      </Grid>}
                                    </Grid>
                                  </Grid>
                                </Grid>
                                }
                              </Grid>
                            </Grid>}

                            { showPaymentCardSection && !showRestrictedStatusSection &&
                            <Grid item xs={12} >
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0} direction="row" justifyContent="flex-start" alignItems="center">
                                    <Grid item xs={12}>
                                      <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                          <Typography align="left" variant="h6" >4. Pay with virtual purchase card</Typography>
                                        </Grid>                          
                                        <Grid item xs={12}>
                                          <Typography variant="body2">Use this virtual purchase card in the credit card payment form for {theApp.appName}.</Typography>
                                        </Grid>
                                        {/*<Grid item>
                                          <Tooltip placement='right' title='Enter this virtual card as the payment method for this subscription.'>
                                            <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                          </Tooltip>
                                        </Grid>*/}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                                    <Hidden smDown>
                                      <Grid item>
                                        <div>
                                          <Grid container spacing={0} direction="column" justifyContent="flex-start" >
                                            <Grid item>
                                              <InputLabel shrink style={{fontSize:"18px", marginBottom:"8px"}}>Billing address</InputLabel>
                                            </Grid>
                                            <Grid item>
                                              <Typography className='appbind-billing-address-name' align="left" variant="h5" data-recording-sensitive><span className='appbind-billing-address-first-name'>{theBindcard.firstName}</span> <span className='appbind-billing-address-last-name'>{theBindcard.lastName}</span></Typography>
                                            </Grid>
                                            <Grid item>
                                              <Typography className='appbind-billing-address-address1' align="left" variant="h5" data-recording-sensitive>{theBindcard.address1}</Typography>
                                            </Grid>
                                            {theBindcard.address2 && theBindcard.address2 !== null && theBindcard.address2 !== 'null' &&
                                            <Grid item>
                                              <Typography className='appbind-billing-address-address2' align="left" variant="h5" data-recording-sensitive>{theBindcard.address2}</Typography>
                                            </Grid>
                                            }
                                            <Grid item>
                                              <Typography align="left" variant="h5" data-recording-sensitive><span className='appbind-billing-address-city'>{theBindcard.city}</span>, <span className='appbind-billing-address-state'>{theBindcard.state}</span>, <span className='appbind-billing-address-country'>{theBindcard.country}</span> <span className='appbind-billing-address-postal-code'>{theBindcard.postalCode}</span></Typography>
                                            </Grid>
                                          </Grid>
                                        </div>
                                      </Grid>
                                      <Grid item>
                                        <BindCardPresentmentII auth={this.props.auth} bcId={theBindcard.bcId} cardToken={theBindcard.extBcId}/>
                                      </Grid>
                                    </Hidden>
                                    <Hidden smUp>
                                      <Grid item>
                                        <div style={{paddingTop:'0px'}}>
                                          <Grid container spacing={0} direction="column" justifyContent="flex-start" >
                                            <Grid item>
                                              <InputLabel shrink style={{fontSize:"18px", marginBottom:"8px"}}>Billing address</InputLabel>
                                            </Grid>
                                            <Grid item>
                                              <Typography align="left" variant="subtitle1" style={{lineHeight: '1.3'}} data-recording-sensitive>{theBindcard.firstName} {theBindcard.lastName}</Typography>
                                            </Grid>
                                            <Grid item>
                                              <Typography align="left" variant="subtitle1" style={{lineHeight: '1.3'}} data-recording-sensitive>{theBindcard.address1}</Typography>
                                            </Grid>
                                            {theBindcard.address2 && theBindcard.address2 !== null && theBindcard.address2 !== 'null' && 
                                            <Grid item>
                                              <Typography align="left" variant="subtitle1" style={{lineHeight: '1.3'}} data-recording-sensitive>{theBindcard.address2}</Typography>
                                            </Grid>
                                            }
                                            <Grid item>
                                              <Typography align="left" variant="subtitle1" style={{lineHeight: '1.3'}} data-recording-sensitive>{theBindcard.city}, {theBindcard.state}, {theBindcard.country} {theBindcard.postalCode}</Typography>
                                            </Grid>
                                          </Grid>
                                        </div>
                                      </Grid>
                                      <Grid item>
                                        <BindCardPresentmentII auth={this.props.auth} bcId={theBindcard.bcId} cardToken={theBindcard.extBcId}/>
                                      </Grid>
                                    </Hidden>
                                    {showAppBindAddressTip &&
                                    <Grid item xs={12}>
                                      <Paper elevation={1} style={AppBindStyles.tipPaper}>
                                        <Grid container spacing={1} direction="row" justifyContent="flex-start">
                                        <Grid item xs={12}>
                                            <div style={{display:"flex"}}>
                                              <Typography variant="body1">
                                                <strong>Tip.&nbsp;&nbsp;</strong>We’re using this address because AppBind virtual cards are issued from the United States.
                                              </Typography>
                                            </div>
                                          </Grid>      
                                        </Grid>
                                      </Paper>
                                    </Grid>
                                    }

                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>}
                          </Grid>
                        </Paper>
                      </Grid>}

                      {!isAppCancelled && !authOnlySubscription &&
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" >
                            { (showBusinessModelSection === true) &&
                            <Grid item xs={12} >
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0} direction="row" justifyContent="flex-start">
                                    <Grid item xs={12}>
                                      <Typography align="left" variant="h6" >Manage terms</Typography>
                                    </Grid>                          
                                    <Grid item xs={12}>
                                      <Typography variant="body2">Manage the billing terms for this subscription.</Typography>
                                    </Grid>
                                    {/*<Grid item>
                                      <Tooltip placement='right' title='Indicate how charges for this subscription should be paid for. You can expense to yourself, or have AppBind pass expenses to your customer along with an optional markup or discount.'>
                                        <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                      </Tooltip>
                                    </Grid>*/}
                                  </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                  <Grid container spacing={1} justifyContent="space-between">
                                    <Grid item>
                                      <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                          <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Who will pay?"}</Typography>
                                        </Grid>
                                        <Grid item style={AppBindStyles.markupDescription}> 
                                          <Typography variant="caption">Expense directly to your customer, or pay at your expense</Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item > 
                                      <FormControl className={classes.selectField}>
                                        <Select
                                          value={this.getValueForSelectRender(theSubscription.paymentOrder) }
                                          disabled={isAppCancelled || termsLockdown}
                                          onChange={(e) => { 
                                            if (e.target.value === 2) {
                                              this.setState({ paymentOrderMenu: e.target.value, paymentOrder: e.target.value, appMarkupPercentage: 0, wholesaleDiscountPercentage: 0}); 
                                            } else {
                                              this.setState({ paymentOrderMenu: e.target.value, paymentOrder: e.target.value }); 
                                            }
                                          } }
                                          inputProps={{
                                            name: 'paymentOrder',
                                            id: 'payment-order',
                                          }}
                                        >
                                          {showExpenseCust &&
                                          <MenuItem value={1}>{customerAccountName} will pay directly</MenuItem>}
                                          {showExpenseSelf &&
                                          <MenuItem value={2}>I will pay at my expense</MenuItem>}
                                        </Select>
                                      </FormControl>
                                    </Grid>

                                    { theApp.appType === 0 && this.getValueForRender(this.state.paymentOrder, theSubscription.paymentOrder, '') <= 1 &&
                                    <React.Fragment>
                                      {showWholesaleDiscount &&
                                      <React.Fragment>
                                        <Grid item xs={12}/>
                                        <Grid item>
                                          <Grid container direction="column" spacing={0}>
                                            <Grid item>
                                              <Typography variant="body1" style={AppBindStyles.boldLabel}>If you are buying {theApp.appName} with a partner discount, enter it here</Typography>
                                            </Grid>
                                            <Grid item style={AppBindStyles.markupDescription}> 
                                              <Typography variant="caption">(e.g. if you’re charged $80 at a 20% discount, we’ll show the customer a retail price of $100)</Typography>
                                              <Tooltip placement='bottom' title={wholesaleTooltip}>
                                                <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                                              </Tooltip>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid item>
                                          <PercentageTextField 
                                            id="wholesale-disc-percentage"
                                            className={classes.wholesaleDiscountField}
                                            value={this.getValueForRender(this.state.wholesaleDiscountPercentage, theSubscription.wholesaleDiscountPercentage, '') }
                                            showErrMsg={true}
                                            allowNegative={false}
                                            minValue={0}
                                            maxValue={100}
                                            minEnterValue={0}
                                            maxEnterValue={9999}
                                            onChange={(e) => { this.setState({ wholesaleDiscountPercentage: e.target.value }); } }
                                            disabled={isAppCancelled}
                                            textAlign="right"
                                          />
                                        </Grid>
                                      </React.Fragment>
                                      }

                                      <Grid item xs={12}/>
                                      <Grid item>
                                        <Grid container direction="column" spacing={0}>
                                          <Grid item>
                                            <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Add your management fee or discount"}</Typography>
                                          </Grid>
                                          <Grid item style={AppBindStyles.markupDescription}> 
                                            <Typography variant="caption">Add a management fee (e.g. 20%) or a discount (e.g. -10%)</Typography>
                                            <Tooltip placement='bottom' title={'On top of the retail price, you can add your own management fee or discount.'}>
                                              <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item>
                                        <PercentageTextField 
                                          id="app-markup-percentage"
                                          className={classes.markupField}
                                          value={this.getValueForRender(this.state.appMarkupPercentage, theSubscription.appMarkupPercentage, '') }
                                          showErrMsg={true}
                                          allowNegative={true}
                                          minValue={-100}
                                          maxValue={900}
                                          minEnterValue={-9999}
                                          maxEnterValue={9999}
                                          onChange={ (e) => { this.setState({ appMarkupPercentage: e.target.value }); } }
                                          disabled={isAppCancelled || termsLockdown}
                                          textAlign="right"
                                        />
                                      </Grid>

                                      <Grid item xs={12}/>
                                      <Grid item>
                                        <Grid container direction="column" spacing={0}>
                                          <Grid item>
                                            <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Pass payment fees to " + customerAccountName}</Typography>
                                          </Grid>
                                          <Grid item style={AppBindStyles.markupDescription}> 
                                            <Typography variant="caption">AppBind charges 1% plus any credit card fees</Typography>
                                            <Tooltip placement='bottom' title='If funding by credit card, fees are 2.9% US and 3.9% international + $0.30'>
                                              <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item>
                                        <Switch checked={passThroughFees === 1} 
                                                      disabled={isAppCancelled || termsLockdown}
                                                      onChange={(e) => this.togglePassThroughFees(passThroughFees)} 
                                                      value={passThroughFees}
                                                      color="primary"
                                        />
                                      </Grid>
                                      <Grid item xs={12}/>
                                      <Grid item>
                                        <Grid container direction="column" spacing={0}>
                                          <Grid item>
                                            <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Back up funding source with my own"}</Typography>
                                          </Grid>
                                          <Grid item style={AppBindStyles.markupDescription}> 
                                            <Typography variant="caption">You'll automatically be reimbursed</Typography>
                                            <Tooltip placement='bottom' title="When your customer connects an active funding source, we'll charge them for subscriptions that you paid for on their behalf.">
                                              <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item>
                                        <Switch checked={this.getValueForRender(this.state.paymentOrder, theSubscription.paymentOrder, 1) === 1} 
                                                disabled={isAppCancelled}
                                                onChange={(e) => this.handleCheckChange()} 
                                                value={this.getValueForRender(this.state.paymentOrder, theSubscription.paymentOrder, 1)}
                                                color="primary"
                                        />
                                      </Grid>
                                      {!isAppCancelled && termsLockdown &&
                                      <React.Fragment>
                                        <Grid item xs={12}/>
                                        <Grid item>
                                          <Button color="primary" variant="outlined" style={{marginTop: 16}} onClick={() => { this.goToSO(theSubscription.accountTByCustomerAccountId, true); }}>
                                            Change subscription terms
                                          </Button>

                                        </Grid>
                                      </React.Fragment>
                                      }
                                    </React.Fragment>
                                    }
                                    

                                    { theApp.appType === 0 && this.getValueForRender(this.state.paymentOrder, theSubscription.paymentOrder, '') === 2 &&
                                    <Grid item xs={12}>
                                      <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                                        <Grid item>
                                          <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                            <Grid item>
                                              <Typography variant="body1">{viewSubscriptionText}</Typography>
                                            </Grid>
                                            <Grid item>
                                              <Tooltip placement='bottom' title={viewSubscriptionTooltip}>
                                                <HelpOutline fontSize="small" style={{verticalAlign: "-7%", marginLeft: '4px'}}/>
                                                {/* style={{verticalAlign: "-20%", marginLeft: '4px'}} */}
                                              </Tooltip>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid item>
                                          <Switch checked={showSubVal === 1} 
                                                  disabled={isAppCancelled}
                                                  onChange={(e) => this.toggleShowSubscription(showSubVal)} 
                                                  value={showSubVal}
                                                  color="primary"
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    }
                                    <Grid item xs={12}>
                                      <TextField
                                        id="notes" label="Notes" className={classes.notesField}
                                        value={this.getValueForRender(this.state.notes, theSubscription.notes, '') }
                                        fullWidth
                                        multiline
                                        onChange={ (e) => { this.setState({ notes: e.target.value }); } }
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            }

                            { (showNotesSection === true) &&
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0} direction="row" justifyContent="flex-start">
                                    <Grid item xs={12}>
                                      <Typography align="left" variant="h6">Notes</Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                
                                <Grid item xs={12}>
                                  <TextField
                                    id="notes" label="Notes" className={classes.notesField}
                                    value={this.getValueForRender(this.state.notes, theSubscription.notes, '') }
                                    fullWidth
                                    multiline
                                    onChange={ (e) => { this.setState({ notes: e.target.value }); } }
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            }

                            {/* Maintenance Buttons */}
                            <Grid item xs={12} >
                              <Grid container spacing={3} direction="row" justifyContent="space-between">
                                <Grid item>
                                  <SaveButton
                                    buttonStyle={AppBindStyles.bottomButtonPaper12}
                                    snackbarOpen={this.state.saveSnackbarOpen}
                                    autoHideDuration={this.state.saveSnackbarDuration}
                                    status={this.state.saveStatus} 
                                    message={this.state.saveMessage}
                                    disabled={this.disableSave(theSubscription, forwardingEmailList)}
                                    onSaveClick={() => { this._updateCustomerApp(theSubscription.customerAppId, customerAccountId, theSubscription, theBindcard, updateParms, forwardingEmailList); }}
                                    onSnackbarClose={() => { this._onSnackbarClose(); }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>}
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <CustomerAppAudit auth={this.props.auth} history={this.props.history} customerAppId={theSubscription.customerAppId}/>
                        </Paper>
                      </Grid>
                    </Grid>

                    {(redirectedFrom === 'create' || showBuyAnother === true) && !authOnlySubscription &&
                    <Button color="primary" variant="outlined" style={{marginTop: 16, marginRight: 16}} onClick={() => { this.determineBuySubscription(theSubscription.accountTByCustomerAccountId); }}>
                      {buyAnotherLabel}
                    </Button>
                    }
                    {(whoFor === "customer") && 
                    <Button color="primary" variant="outlined" style={{marginTop: 16}} onClick={() => { this.goToCustomerSubscriptions(theBindcard.usingAccountId); }}>
                      {viewSubscriptionsLabel}
                    </Button>
                    }
                                
                    {/*<ConfirmationDialog
                        open={this.state.confirmTransfer}
                        onClose={() => { this.setState({confirmTransfer:false, anchorEl: null});}}
                        onConfirm={() => { this._transferSubscription(theApp.appName, theSubscription.accountTByCustomerAccountId.accountName);}}
                        onCancel={() => { }}
                        title="Transfer subscription?"
                        cancelBtn="No"
                        okBtn="Yes, transfer subscription"
                      >
                        Your request to transfer control of this subscription to your customer will be sent to AppBind support.  Do you wish to proceed?
                    </ConfirmationDialog>*/}
                    <ConfirmationDialog
                        open={this.state.confirmCancel}
                        onClose={() => { this.setState({confirmCancel:false, anchorEl: null});}}
                        onConfirm={() => { this._cancelSubscription(theSubscription.customerAppId, theBindcard.provisioningAccountId, customerAccountId);}}
                        onCancel={() => { }}
                        title="Cancel subscription?"
                        cancelBtn="No"
                        okBtn="Yes, cancel subscription"
                        irreversibleAction={true}
                      >
                        {cancelConfirmMessage}
                    </ConfirmationDialog>
                    <ConfirmationDialog
                        open={this.state.confirmSuspend}
                        onClose={() => { this.setState({confirmSuspend:false, anchorEl: null});}}
                        onConfirm={() => { this._suspendSubscription(theSubscription.customerAppId, theBindcard.provisioningAccountId, customerAccountId);}}
                        onCancel={() => { }}
                        title="Suspend subscription?"
                        cancelBtn="No"
                        okBtn="Yes, suspend subscription"
                      >
                        {suspendConfirmMessage}
                    </ConfirmationDialog>
                    <ConfirmationDialog
                        open={this.state.confirmUnsuspend}
                        onClose={() => { this.setState({confirmUnsuspend:false, anchorEl: null});}}
                        onConfirm={() => { this._unsuspendSubscription(theSubscription.customerAppId, theBindcard.provisioningAccountId, customerAccountId);}}
                        onCancel={() => { }}
                        title="Unsuspend subscription?"
                        cancelBtn="No"
                        okBtn="Yes, unsuspend subscription"
                      >
                        {unsuspendConfirmMessage}
                    </ConfirmationDialog>
                  </Grid>
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  _cancelSubscription(customerAppId, provisioningAccountId, customerAccountId)
  {

    const { logError } = this.props.auth;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "updateSubscriptionStatus",
      params: {
        pJwt: aPjwt,
        provisioningAccountId: provisioningAccountId,
        customerAccountId: customerAccountId,
        customerAppId: customerAppId,
        status: 2
      }
    };


    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
   .then(response => {

      this.goBack();
    })
    .catch(error => {
      logError('Exception in SubscriptionManage.js: ' + error);
     });
  }

  _suspendSubscription(customerAppId, provisioningAccountId, customerAccountId)
  {
    const { logError } = this.props.auth;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "updateSubscriptionStatus",
      params: {
        pJwt: aPjwt,
        provisioningAccountId: provisioningAccountId,
        customerAccountId: customerAccountId,
        customerAppId: customerAppId,
        status: 1
      }
    };


    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
   .then(response => {

      this.goBack();
    })
    .catch(error => {
      logError('Exception in SubscriptionManage.js: ' + error);
     });

  }

  _unsuspendSubscription(customerAppId, provisioningAccountId, customerAccountId)
  {
    const { logError } = this.props.auth;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "updateSubscriptionStatus",
      params: {
        pJwt: aPjwt,
        provisioningAccountId: provisioningAccountId,
        customerAccountId: customerAccountId,
        customerAppId: customerAppId,
        status: 0
      }
    };


    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
   .then(response => {

      this.goBack();
    })
    .catch(error => {
      logError('Exception in SubscriptionManage.js: ' + error);
     });
  }

  _updateCustomerApp(customerAppId, accountId, subscription, bindcard, updateParms, forwardingEmailList) {

    const { callPartnerApi, encryptOneTimeEncryptedValue } = this.props.auth;

    this.setState({ saveStatus: 'saving', showSpinner: true });
    const { appStatus, appSkuPrice, appMarkupPercentage, appMarkupAbsolute, notes, paymentOrder, shareCredentials, showSubscription, passThroughFees, wholesaleDiscountPercentage, domain, username } = this.state;

    let newUseEmail = this.state.useEmail;

    let needReload = false;

    Promise.resolve()  
    .then(() => {
      // If the password has changed, then we need to encrypt it and send it to the server.
      if (this.state.unencryptPwdChanged === true) {
        // encrypt
        return encryptOneTimeEncryptedValue(this.state.unencryptPwd, callPartnerApi);
      } else {
        return null;
      }
    })
    .then((jresp) => {
      if (jresp != null && jresp.status === 0) {
        let theKeyId = jresp.keyId;
        let encryptedData = jresp.encryptedData;

        let theForwardingEmailList = null;
        if (this.state.changedEmails && this.state.changedEmails.length > 0) {
          theForwardingEmailList = forwardingEmailList;
        }
  
        let payload = {
          operation: "updateSubscription",
          params: {
            "usingAccountId": accountId,
            "provisioningAccountId": bindcard.provisioningAccountId,
            "customerAppId": customerAppId,
            "keyId": theKeyId,
            "encryptedData": encryptedData,
            "appStatus": appStatus,
            "appSkuPrice": appSkuPrice, 
            "appMarkupPercentage": appMarkupPercentage, 
            "appMarkupAbsolute": appMarkupAbsolute, 
            "notes": notes,
            "paymentOrder": paymentOrder,
            "useEmail": newUseEmail,
            "shareCredentials": shareCredentials, 
            "showSubscription": showSubscription, 
            "passThroughFees": passThroughFees, 
            "wholesaleDiscountPercentage": wholesaleDiscountPercentage, 
            "domain": domain, 
            "username": username,
            "forwardingEmailList": theForwardingEmailList
          }
        };
  
        return callPartnerApi('appbind/generic',
                              'POST',
                                payload);

      } else {
        let theForwardingEmailList = null;
        if (this.state.changedEmails && this.state.changedEmails.length > 0) {
          theForwardingEmailList = forwardingEmailList;
        }

        let payload = {
          operation: "updateSubscription",
          params: {
            "usingAccountId": accountId,
            "provisioningAccountId": bindcard.provisioningAccountId,
            "customerAppId": customerAppId,
            "unencryptedString": this.state.unencryptPwd,
            "appStatus": appStatus,
            "appSkuPrice": appSkuPrice, 
            "appMarkupPercentage": appMarkupPercentage, 
            "appMarkupAbsolute": appMarkupAbsolute, 
            "notes": notes,
            "paymentOrder": paymentOrder,
            "useEmail": newUseEmail,
            "shareCredentials": shareCredentials, 
            "showSubscription": showSubscription, 
            "passThroughFees": passThroughFees, 
            "wholesaleDiscountPercentage": wholesaleDiscountPercentage, 
            "domain": domain, 
            "username": username,
            "forwardingEmailList": theForwardingEmailList
          }
        };

        return callPartnerApi('appbind/generic',
                              'POST',
                                payload);
      }

    })
    .then(() => {
      if (updateParms != null) {
        // This means that there isn't a bindcard provisioned, but either the using account or
        // provisioning account does have a funding source on file.  So check to see if the
        // payment order now qualifies for creating a virtual card.

        let usingAccountHasPaymentSource        = updateParms.usingHasPs;
        let provisioningAccountHasPaymentSource = updateParms.provisioningHasPs;
        let theBindcard                         = updateParms.bindCard;

        // Expense to reseller
        if (paymentOrder === 2 && provisioningAccountHasPaymentSource) {
          // Attach bindbards for any subscriptions created
          let aPjwt = abEnvironment.getPjwt();
          let provisioningAccountId = theBindcard.provisioningAccountId;
          let payload = {
            operation: "checkAndAttachBindcards",
            params: {
              pJwt:      aPjwt,
              accountId: provisioningAccountId
            }
          };
          needReload = true;
          return callPartnerApi('appbind/generic',
                                'POST',
                                payload);
        }
        else if (paymentOrder === 1 && usingAccountHasPaymentSource) {
          // Attach bindbards for any subscriptions created
          let aPjwt = abEnvironment.getPjwt();
          let usingAccountId = theBindcard.usingAccountId;
          let payload = {
            operation: "checkAndAttachBindcards",
            params: {
              pJwt:      aPjwt,
              accountId: usingAccountId
            }
          };
          
          needReload = true;
          return callPartnerApi('appbind/generic',
                                'POST',
                                payload);
        }
      }
      return null;
    }).then(()=> {
      if (needReload) {
        window.location.reload();
      } else {
        // force a refetch
        this.setState({ forceFetch: this.state.forceFetch + 1, changedEmails: null, unencryptPwdChanged: false, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Subscription saved.', saveSnackbarDuration: 3000 });

        /*
        //if emails are changed, we must force a fetch again.
        if (this.state.changedEmails && this.state.changedEmails.length > 0) {
          this.setState({ forceFetch: this.state.forceFetch + 1, changedEmails: null, unencryptPwdChanged: false, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Subscription saved.', saveSnackbarDuration: 3000 });
        } else {
          this.setState({ unencryptPwdChanged: false, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Subscription saved.', saveSnackbarDuration: 3000 });
        }
        */
      }
    })
    .catch(error => {
      this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save subscription', saveSnackbarDuration: null });
    });
  }

  _onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }

  handleFromCreateSnackbarClose() {

    this.setState({fromCreateSB: false})
  }

  /*sendMessage(theMessage) {
    let extensionId = 'kgdijkikhlipndjcnffdgafibdobaknl';

    return new Promise((resolve) => {
      window.chrome.runtime.sendMessage(extensionId, theMessage, function(theresp) {
        resolve(theresp);
      })
    });
  }*/

  /*
  launchLink(link, app, bindcard, appId, customerAppId) {
    let goto = link;
    if (this.state.linkURL === null) {
      this._updateAppLink(appId, link, customerAppId);
    } else {
      goto = this.state.linkURL; 
      this._updateAppLink(appId, this.state.linkURL, customerAppId);
    }

    let nameOnCard = bindcard.firstName + ' ' + bindcard.lastName;
    let thefill = {
      filldata: {
        appname: app.appName,
        domain: 'appbind',
        sharedemail: 'apical.activecampaign@pmail.appbind.com',
        user: '',
        password: '',
        cnum: '2342234223422342',
        cvc: '123',
        cexp: '1222',
        cname: nameOnCard,
        caddr1: bindcard.address1,
        ccity: bindcard.city,
        cstate: bindcard.state,
        czip: bindcard.postalCode
      },
      theapp: {
        name: 'ActiveCampaign',
        url: goto,
        domain: 'apattern',
      }
    }

    let theMessage = {
      message: "gotoapp",
      url: goto,
      fill: thefill
    };

    this.sendMessage(theMessage)
    .then(resp => {
      if (resp && resp.type && resp.type == 'success') {
        // Opened incognito
      } else {
        window.open(goto, "_blank");
      }
    })
  }
  */
}


SubscriptionManage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(SubscriptionManage);
